import { type ScoreFactAttributes } from './generated/ScoreFactAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ScoreFact extends ScoreFactAttributes {}

@model
class ScoreFact extends ApplicationModel {
  // Start auto-generated
  static typename: 'ScoreFact' = 'ScoreFact';
  get typename(): 'ScoreFact' {
    return 'ScoreFact';
  }

  static internalTypename: 'ScoreFact' = 'ScoreFact';
  get internalTypename(): 'ScoreFact' {
    return 'ScoreFact';
  }

  static fields = {
    equationActive: attr({ readable: true }),
    equationType: attr({ readable: true }),
    id: attr({ readable: true }),
    value: attr({ readable: true }),
    scoringSystemMetric: attr.belongsTo({
      readable: true,
      typename: 'ScoringSystemMetric',
    }),
  };
  // End auto-generated

  /**
   * value is readonly in the graphql schema, but we need to be able to set it
   * for writing in the parent record
   */
  set value(newValue: number) {
    this.setAttribute('value', newValue);
  }
}

export default ScoreFact;
